<template>
  <div class="m-3 z-50 absolute flex flex-col inline-block bg-white rounded-lg w-16 overflow-hidden shadow-lg">
    <button class="bg-white border-0 text-4xl w-16 h-16" v-on:click="zoomIn">
      +
    </button>
    <hr class="w-16 h-px bg-gray m-0"/>
    <button class="bg-white border-0 text-4xl w-16 h-16" v-on:click="zoomOut">
      -
    </button>
    <hr v-if="$root.rotatable" class="w-16 h-px bg-gray m-0"/>
    <div v-if="$root.rotatable" v-on:click="$root.rotate()"
         class="cursor-pointer w-16 h-16 p-4">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<path d="M351.68,53.653c69.653,33.067,119.68,100.8,127.253,181.013h32C500.053,103.253,390.187,0,256,0
	c-4.8,0-9.387,0.427-14.187,0.747L323.2,82.133C323.2,82.133,351.68,53.653,351.68,53.653z M218.24,37.227
	c-12.48-12.48-32.747-12.48-45.227,0L37.227,173.013c-12.48,12.48-12.48,32.747,0,45.227l256.427,256.427
	c12.48,12.48,32.747,12.48,45.227,0L474.667,338.88c12.48-12.48,12.48-32.747,0-45.227L218.24,37.227z M316.373,452.053
	L59.84,195.627L195.627,59.84l256.427,256.427L316.373,452.053z M160.32,458.347C90.667,425.28,40.64,357.547,33.067,277.333h-32
	C11.947,408.747,121.813,512,256,512c4.8,0,9.387-0.427,14.187-0.747L188.8,429.867L160.32,458.347L160.32,458.347z"/>
</svg>

    </div>
  </div>

</template>

<script>
export default {
  name: "Zoom",

  methods: {
    zoomIn() {
      this.$root.print.zoom++;
    },
    zoomOut() {
      this.$root.print.zoom--;
    },
  }
}
</script>

<style scoped>

</style>